import {ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Output} from '@angular/core';
import {WindowSizeService} from '../../../../services/window-size.service';

@Component({
  selector: 'app-top-content-space',
  templateUrl: './top-content-space.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopContentSpaceComponent {
  @Output() topSpacerInViewportUpdated = new EventEmitter<boolean>();
  private readonly defaultMobileTopSearchSpacerHeight: number = 117;
  private readonly defaultDesktopTopSearchSpacerHeight: number = 64;
  private readonly mobileTreshold: number = 768;
  private windowSizeService = inject(WindowSizeService);
  private size = this.windowSizeService.windowSize;
  isMobile = computed<boolean>(() => this.size() && this.size()[0] < this.mobileTreshold);
  topSearchSpacerHeight = computed<number>(() =>
    this.isMobile() ? this.defaultMobileTopSearchSpacerHeight : this.defaultDesktopTopSearchSpacerHeight,
  );

  public handleSpacerViewport({target, visible}: {target: Element; visible: boolean}): void {
    this.topSpacerInViewportUpdated.emit(visible);
  }
}
